import { Controller } from "stimulus";

const MODAL_ID = "equalAccreditationEvidenceModal";

export default class extends Controller {
  connect() {
    this.handleCloseClick = this.close.bind(this);
    document.addEventListener("click", this.handleCloseClick);
  }

  disconnect() {
    document.removeEventListener("click", this.handleCloseClick);
  }

  prefetchBody(event) {
    const targetId = (event.currentTarget.getAttribute("data-target") || "").replace(
      "#",
      ""
    );
    const body = document.getElementById(targetId);
    if (body) {
      this.ensureLoaded(body);
    }
  }

  async open(event) {
    event.preventDefault();

    const trigger = event.currentTarget;
    const modalId = trigger.dataset.modalId;
    if (!modalId) {
      return;
    }

    const modalEl = this.modalElement();
    const titleEl = document.getElementById(`${MODAL_ID}Label`);
    const bodyTarget = modalEl.querySelector(".equal-accreditation-evidence-modal__body");
    const externalLink = modalEl.querySelector("[data-equal-accreditation-evidence-external-link]");

    if (titleEl) {
      titleEl.textContent = trigger.dataset.modalTitle || "Evaluation detail";
    }

    if (bodyTarget) {
      bodyTarget.innerHTML = '<p class="text-muted mb-0">Loading…</p>';
    }

    const externalPath = trigger.dataset.externalPath;
    if (externalLink) {
      if (externalPath) {
        externalLink.href = externalPath;
        externalLink.classList.remove("d-none");
      } else {
        externalLink.classList.add("d-none");
      }
    }

    if (modalEl.parentElement !== document.body) {
      this.modalHost = this.element;
      document.body.appendChild(modalEl);
    }

    this.showModal(modalEl);

    let content = this.contentFor(modalId);
    if (!content) {
      const loadTarget = this.loadTargetFor(modalId);
      if (loadTarget) {
        content = await this.ensureLoaded(loadTarget);
      } else if (trigger.dataset.loadUrl) {
        content = await this.fetchHtml(trigger.dataset.loadUrl);
      }
    }

    if (bodyTarget) {
      bodyTarget.innerHTML = content || "<p class='text-muted mb-0'>Evidence not found.</p>";
    }
  }

  close(event) {
    if (!event.target.closest("[data-equal-accreditation-evidence-modal-close]")) {
      return;
    }

    event.preventDefault();
    this.hideModal(this.modalElement());
  }

  modalElement() {
    return document.getElementById(MODAL_ID);
  }

  contentFor(modalId) {
    const source = document.getElementById(`${modalId}-modal-source`);
    if (source && source.innerHTML.trim() && !this.isPlaceholder(source)) {
      return source.innerHTML;
    }

    const body = document.getElementById(`${modalId}-body`);
    if (body && body.innerHTML.trim() && !this.isPlaceholder(body)) {
      return body.innerHTML;
    }

    const selector = `[data-equal-evidence-ids~="${modalId}"]`;
    const aliased = document.querySelector(selector);
    if (aliased && aliased.innerHTML.trim() && !this.isPlaceholder(aliased)) {
      return aliased.innerHTML;
    }

    return null;
  }

  loadTargetFor(modalId) {
    return (
      document.getElementById(`${modalId}-body`) ||
      document.querySelector(`[data-equal-evidence-ids~="${modalId}"]`)
    );
  }

  isPlaceholder(element) {
    return Boolean(element.dataset.equalEvidenceLoadUrl) &&
      element.dataset.equalEvidenceLoaded !== "true";
  }

  async ensureLoaded(element) {
    if (element.dataset.equalEvidenceLoaded === "true") {
      return element.innerHTML;
    }

    const url = element.dataset.equalEvidenceLoadUrl;
    if (!url) {
      return element.innerHTML;
    }

    const html = await this.fetchHtml(url);
    if (html) {
      element.innerHTML = html;
      element.dataset.equalEvidenceLoaded = "true";
    }

    return html;
  }

  async fetchHtml(url) {
    try {
      const response = await fetch(url, {
        headers: { Accept: "text/html" },
        credentials: "same-origin",
      });
      if (!response.ok) {
        return null;
      }
      return await response.text();
    } catch (error) {
      return null;
    }
  }

  showModal(modalEl) {
    const $ = window.jQuery || window.$;

    if ($ && $.fn.modal) {
      $(modalEl).modal("show");
      return;
    }

    modalEl.classList.add("show");
    modalEl.style.display = "block";
    modalEl.removeAttribute("aria-hidden");
    document.body.classList.add("modal-open");

    if (!document.querySelector(".modal-backdrop")) {
      const backdrop = document.createElement("div");
      backdrop.className = "modal-backdrop fade show";
      document.body.appendChild(backdrop);
    }
  }

  hideModal(modalEl) {
    const $ = window.jQuery || window.$;

    if ($ && $.fn.modal) {
      $(modalEl).modal("hide");
      return;
    }

    modalEl.classList.remove("show");
    modalEl.style.display = "none";
    modalEl.setAttribute("aria-hidden", "true");
    document.body.classList.remove("modal-open");
    document.querySelectorAll(".modal-backdrop").forEach((element) => element.remove());
  }
}
